import { Component, AfterViewInit, OnInit } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DocumentsService } from '../../services/documents/documents.service';

@Component({
    selector: 'app-safety',
    imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatToolbarModule,
    RouterModule,
    MatIconModule,
    MatProgressSpinnerModule
],
    templateUrl: './safety.component.html',
    styleUrl: './safety.component.css'
})
export class SafetyComponent implements OnInit, AfterViewInit {

  blankJsaLoading = true;
  blankJsaUrl: string | null = null;
  blankFirstAidLoading = true;
  blankFirstAidUrl: string | null = null;
  safetyHandbookLoading = true;
  safetyHandbookUrl: string | null = null;

  constructor(private documentsService: DocumentsService) {}

  ngOnInit() {
    this.loadSingletonUrl('Safety', 'Blank JSA', (url) => { this.blankJsaUrl = url; this.blankJsaLoading = false; });
    this.loadSingletonUrl('Safety', 'Blank First Aid Report', (url) => { this.blankFirstAidUrl = url; this.blankFirstAidLoading = false; });
    this.loadSingletonUrl('Safety', 'Safety Handbook', (url) => { this.safetyHandbookUrl = url; this.safetyHandbookLoading = false; });
  }

  ngAfterViewInit() {
    setTimeout(() => this.slightScrollOnLoad(), 200);
 }

 private slightScrollOnLoad() {
  window.scrollBy({ top: 180, left: 0, behavior: 'smooth' });
}

  private loadSingletonUrl(category: string, subcategory: string, onResolved: (url: string | null) => void): void {
    this.documentsService.getSingleDocument(category, subcategory).subscribe({
      next: (doc) => {
        if (!doc) { onResolved(null); return; }
        this.documentsService.getSignedUrl(doc._id).subscribe({
          next: ({ url }) => onResolved(url),
          error: (err) => { console.error(`Failed to resolve ${category}/${subcategory} document:`, err); onResolved(null); },
        });
      },
      error: (err) => { console.error(`Failed to load ${category}/${subcategory} document:`, err); onResolved(null); },
    });
  }

}
